import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  viewType: "grid",
  drawer: true, // default is true, meaning opened
  cart: false,
  drawerMobile: false,
};

const viewSlice = createSlice({
  name: "view",
  initialState,
  reducers: {
    setViewType: (state, action) => {
      state.viewType = action.payload;
    },
    toggleDrawer: (state) => {
      state.drawer = !state.drawer;
    },
    toggleDrawerMobile: (state) => {
      state.drawerMobile = !state.drawerMobile;
    },
    setDrawer: (state, action) => {
      state.drawer = action.payload;
    },
    toggleCart: (state) => {
      state.cart = !state.cart;
    },
  },
});

export const {
  setViewType,
  toggleDrawer,
  setDrawer,
  toggleCart,
  toggleDrawerMobile,
} = viewSlice.actions;

export default viewSlice.reducer;
